export const insets = {
    get top() {
        return +getComputedStyle(document.documentElement).getPropertyValue('--sat').replace('px', '') || 0;
    },
    get right() {
        return +getComputedStyle(document.documentElement).getPropertyValue('--sar').replace('px', '') || 0;
    },
    get bottom() {
        return +getComputedStyle(document.documentElement).getPropertyValue('--sab').replace('px', '') || 0;
    },
    get left() {
        return +getComputedStyle(document.documentElement).getPropertyValue('--sal').replace('px', '') || 0;
    },
};

export const device = {
    get isStandalone() {
        return matchMedia('(display-mode: standalone)').matches;
    },

    get isLandscape() {
        return matchMedia('(max-height: 561px) and (orientation: landscape)').matches;
    },

    get isWideScreen() {
        return matchMedia('(min-aspect-ratio: 910/768)').matches;
    },

    get isShortScreen() {
        return !matchMedia('(min-height: 667px), (min-device-height: 667px) and (display-mode: standalone)').matches;
    },
};

export function computeScale() {
    const w = window.innerWidth;
    const h = window.innerHeight;

    let tw = 375;
    let th = 560;
    if (!device.isShortScreen) {
        tw = 375;
        th = 640;
    }

    return Math.min(w / tw, h / th);
}
